module.exports = __webpack_public_path__ + "static/media/signAgreement.12ae1045.svg";